export const USER_STYLES_DRAWER = 'UserStylesDrawer';
export const GLOBAL_STYLES_DRAWER = 'GlobalStylesDrawer';
export const BLOG_DRAWER = 'BlogDrawer';
export const MULTI_PAGE_DRAWER = 'MultiPageDrawer';
export const ADD_ELEMENT_DRAWER = 'AddElementDrawer';
export const ADD_ECOMMERCE_STORE_DRAWER = 'AddEcommerceStoreDrawer';
export const MANAGE_ECOMMERCE_STORE_DRAWER = 'ManageEcommerceStoreDrawer';
export const WEBSITE_IMPORTER_DRAWER = 'WebsiteImporterDrawer';
export const AI_WRITER_DRAWER = 'AiWriterDrawer';
